import React from 'react'
import { Box as Card, Box as Container, Box as Group } from '@node-space/ui-components'
import { IntegrationsLanding } from './pages/IntegrationsLanding'

export const Integrations = () => {
  return (
    <Card width="full">
      <Container flex flexCol centerChildren gapY={24}>
        <Group
          flex
          flexCol
          centerChildren
          gapY={24}
          className="w-full"
          id="integrations-header-card-description"
        >
          <IntegrationsLanding />
        </Group>
      </Container>
    </Card>
  )
}
